<transition name="modal">
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-header">
          <i class="close icon" v-on:click="$emit('close')"></i>
          <h3>{{ type }} Category</h3>
        </div>

        <div class="ui divider"></div>

        <div class="modal-body scrolling content">
          <form class="ui form">

            <h4 class="ui header">
              Category Details
            </h4>

            <div class="two fields">
              <div class="field settings" :class="{ error: errors.name }">
                <label>Name*</label>
                <input 
                  placeholder="Enter Category Name" 
                  type="text" 
                  v-model="category.name" 
                  maxlength="255">
                <div v-if="errors.name" class="error-message">{{ errors.name }}</div>
              </div>
              
              <div class="field settings">
                <label>Parent (Optional)</label>
                <app-select
                  :defaultLabel="'Select Parent Category'"
                  :items="availableParentCategories"
                  :value="category.parent_id"
                  @selected="category.parent_id = $event.id">
                </app-select>
              </div>
            </div>
            
            <div class="field" :class="{ error: errors.description }">
              <label>Instructional Notes (Optional)</label>
              <textarea 
                rows="3" 
                placeholder="Enter instructional notes"
                v-model="category.description" 
                maxlength="1000"></textarea>
              <div v-if="errors.description" class="error-message">{{ errors.description }}</div>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <a href="#" 
             class="ui left floated negative basic button" 
             v-if="category.id" 
             v-on:click="deleted"
             :class="{ loading: loading }">
            <i class="trash alternate outline icon"></i>Trash
          </a>
          <div class="ui basic button smardie-btn-secondary" v-on:click="closeModal" :disabled="loading">Cancel</div>
          <div class="ui right primary button" 
               v-on:click="save" 
               :class="{ loading: loading }"
               :disabled="loading">
            {{ loading ? 'Saving...' : 'Save' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</transition>
